import axios from 'axios'
import { getFundClick } from '@/api'
//地址
//必须为HTTPS 不然IOS 会取消请求
export const fetchInfoDomainData = async () => {
  try {
    const response = await axios({
      // url: 'https://api.hbty002.cn/task/getDomain?hh=bx107&cs=2&pp=1',
      url: 'https://api.wljw21.cn/task/getDomain?hh=bx107&cs=2&pp=1',
      method: 'get'
    })
    return response.data.url
  } catch (error) {
    console.error('详情页返回URL获取错误', error)
  }
}
//埋点信息
export const handleInfoGoBack = (uuid, domainData) => {
  const data = {
    entity: `official-account-click`,
    content: `{
                  "key":"详情页返回点击转发",
                  "partners": "无穷1",
                  "uuid":"${uuid}"
              }`,
    partners: '无穷1',
    uuid: uuid
  }
  getFundClick(data)
    .then(() => {
      window.location.href = domainData
    })
    .catch(() => {})
}

//地址1
//必须为HTTPS 不然IOS 会取消请求
export const fetchInfoDomainData1 = async () => {
  try {
    const response = await axios({
      url: 'https://api.hbty002.cn/task/getDomain?hh=bx107&cs=2&pp=1',
      method: 'get'
    })
    return response.data.url
  } catch (error) {
    console.error('详情页返回URL获取错误', error)
  }
}
//埋点信息
export const handleInfoGoBack1 = (uuid, domainData) => {
  const data = {
    entity: `official-account-click`,
    content: `{
                    "key":"详情页返回",
                    "partners": "无穷1",
                    "uuid":"${uuid}"
                }`,
    partners: '无穷1',
    uuid: uuid
  }
  getFundClick(data)
    .then(() => {
      window.location.href = domainData
    })
    .catch(() => {})
}
